import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
/**
 * Footer Component
 *
 * @export FooterComponent
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  /**
   * Version variable of the app
   */
  version = '0.0.1';

  /**
   * Creates an instance of FooterComponent.
   */
  constructor() {}

  /**
   * Does nothing
   */
  ngOnInit() {
    this.version = environment.version; // + '(' + environment.env + ')';
  }
}
